// extracted by mini-css-extract-plugin
module.exports = {"grey":"CitiesChips_grey__3eiCg","green":"CitiesChips_green__1-3Ec","container":"CitiesChips_container__1fSpk"};